import prepareComponent from "@bluframe/grapple/prepareComponent"
import { Props as PaginationProps } from "components/Pagination"
import { ChangeEvent, useEffect, useRef } from "react"

import { Props as ItemProps } from "./Item"
import List from "./List"

export interface Props {
  hasAdd?: boolean
  hasSearch?: boolean
  isAdmin?: boolean
  isEditor?: boolean
  isSearchLoading?: boolean
  items?: ItemProps[]
  label: string
  loading?: boolean
  onAdd: () => void

  onSearchChange?: (event: ChangeEvent<HTMLInputElement>) => void
  pagination?: PaginationProps
}

export interface ComponentProps extends Props {
  searchRef: React.RefObject<HTMLInputElement | null>
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const searchRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (props.hasSearch) {
      searchRef?.current?.focus()
    }
  }, [props.hasSearch])

  return {
    ...props,
    searchRef
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  List
)
